<app-navbar></app-navbar>
<main>
  <router-outlet></router-outlet>
</main>
<app-footer class="d-block bg-light"></app-footer>